import { defineComponent } from "vue";

export default defineComponent({
    template: `
        <div class="FormInfo" :class="[ 'FormInfo--' + type ]">
            <div class="FormInfo__title">
                <span>{{ title }}</span>

                <button v-if="tip" type="button" class="LabeledInput__tip">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <g clip-path="url(#clip0_13282_29477)">
                            <path d="M7.22656 11.9003C7.22656 12.327 7.57323 12.6736 7.9999 12.6736C8.42656 12.6736 8.77323 12.327 8.77323 11.9003C8.77323 11.4736 8.42656 11.127 7.9999 11.127C7.57323 11.127 7.22656 11.4736 7.22656 11.9003ZM8.29323 11.9003C8.29323 12.0603 8.1599 12.1936 7.9999 12.1936C7.8399 12.1936 7.70656 12.0603 7.70656 11.9003C7.70656 11.7403 7.8399 11.607 7.9999 11.607C8.1599 11.607 8.29323 11.7403 8.29323 11.9003Z" fill="#005537"/>
                            <path d="M13.0271 3.56711C12.7938 3.74711 12.7471 4.08044 12.9204 4.31378C13.7271 5.38044 14.1471 6.66044 14.1471 8.00044C14.1471 11.3871 11.3871 14.1471 8.00044 14.1471C4.61378 14.1471 1.85378 11.3871 1.85378 8.00044C1.85378 4.61378 4.61378 1.85378 8.00044 1.85378C9.23378 1.85378 10.4204 2.21378 11.4338 2.90044C11.6804 3.06711 12.0071 3.00044 12.1738 2.76044C12.3404 2.51378 12.2738 2.18711 12.0271 2.02044C10.8338 1.21378 9.44044 0.787109 7.99378 0.787109C4.02044 0.787109 0.787109 4.02044 0.787109 8.00044C0.787109 11.9804 4.02044 15.2138 8.00044 15.2138C11.9804 15.2138 15.2138 11.9804 15.2138 8.00044C15.2138 6.42711 14.7138 4.92711 13.7738 3.67378C13.5938 3.44044 13.2604 3.39378 13.0271 3.56711Z" fill="#005537"/>
                            <path d="M9.77316 7.52703C10.2465 7.0537 10.5065 6.42036 10.5065 5.7137C10.5065 4.32703 9.37983 3.20703 7.99983 3.20703C6.61983 3.20703 5.49316 4.3337 5.49316 5.7137C5.49316 6.00703 5.73316 6.24703 6.0265 6.24703C6.31983 6.24703 6.55983 6.00703 6.55983 5.7137C6.55983 4.92036 7.2065 4.26703 7.99983 4.26703C8.79316 4.26703 9.43983 4.9137 9.43983 5.7537C9.43983 6.14036 9.2865 6.50036 9.01983 6.7737L8.5465 7.24703C7.85316 7.94036 7.47316 8.86036 7.47316 9.84036C7.47316 10.1337 7.71316 10.3737 8.0065 10.3737C8.29983 10.3737 8.53983 10.1337 8.53983 9.84036C8.53983 9.14703 8.81316 8.4937 9.29983 8.00036L9.77316 7.52703Z" fill="#005537"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_13282_29477">
                            <rect width="16" height="16" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </button>
            </div>
            <div class="FormInfo__sep"></div>
            <div class="FormInfo__value" v-html="value"></div>
        </div>
    `,

    emits: [
        'tip',
    ],

    props: {
        type: { type: String, default: "1" },
        title: { type: String, required: true },
        value: { type: String },

        tip: { type: Boolean, default: false },
    },
});
